import React, { Component } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
export function WhatsAppButton() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const message = en ? 'Hello, I am interested in D-TECH equipment.' : ru ? 'Здравствуйте, меня интересует оборудование D-TECH.' : 'Poštovani, interesuje me D-TECH oprema.';
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/381653312811?text=${encodedMessage}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-40 group" aria-label="Contact us on WhatsApp" data-id="element-420">
      <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-25 group-hover:opacity-40 transition-opacity duration-300" data-id="element-421"></div>
      <div className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg transform transition-transform duration-300 group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(37,211,102,0.5)]" data-id="element-422">
        <MessageCircleIcon className="w-7 h-7 text-white" data-id="element-423" />
      </div>
    </a>;
}